var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 76,
    viewBox: "0 0 120 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 71.3042C120 72.6806 119.983 74.043 119.948 75.3908C119.913 76.7386 114.899 75 114.952 73.1024C114.984 71.9475 115 72.7802 115 71.6008C115 43.9372 106.181 25.1477 88.3867 16.2258C88.2702 16.2815 88.1425 16.3351 88.0032 16.3866C76.0343 20.8126 44.4036 21.1401 30.0986 16.4879C12.649 25.5126 4 44.2052 4 71.6008V73.5C4 75 1.12622 76.4089 0.0524101 75.3908C0.0174637 74.043 0 72.6807 0 71.3042C0 25.1645 19.6241 0.259514 59.3708 0C64.6159 0.0339392 69.8929 0.490898 75.2658 1.37302C105.197 7.17635 120 31.2316 120 71.3042Z",
    className: "Hair",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0375 2.00161C63.6957 19.3661 72.9697 30.9948 87.9975 31.938C89.0999 32.0072 90.0002 31.0845 89.9997 29.98C89.9879 0.653582 89.451 0.0137196 65.0117 0.000281473C63.9071 -0.000326923 62.9957 0.897838 63.0375 2.00161Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9625 2.00162C59.3043 19.3661 50.0303 30.9948 35.0025 31.938C33.9001 32.0072 32.9998 31.0845 33.0003 29.98C33.0121 0.653585 33.549 0.0137214 57.9883 0.000281195C59.0929 -0.00032539 60.0043 0.897839 59.9625 2.00162Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2276 26.9614C24.8892 15.8598 28.5914 6.96044 37.4822 3.61047C38.5159 3.22101 39.6189 3.86503 39.9039 4.9322C44.8797 23.5649 44.5739 24.3601 29.6345 28.3883C28.568 28.6758 27.4552 28.0423 27.2276 26.9614Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8535 26.9614C98.1919 15.8598 94.4897 6.96044 85.5988 3.61047C84.5652 3.22101 83.4622 3.86503 83.1772 4.9322C78.2014 23.5649 78.5072 24.3601 93.4465 28.3883C94.513 28.6758 95.6258 28.0423 95.8535 26.9614Z",
    className: "Hair"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9625 2.00162C72.3043 19.3661 63.0303 30.9948 48.0025 31.938C46.9001 32.0072 45.9998 31.0845 46.0003 29.98C46.0121 0.653585 46.549 0.0137214 70.9883 0.000281195C72.0929 -0.00032539 73.0043 0.897839 72.9625 2.00162Z",
    className: "Hair"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0375 2.00162C50.6957 19.3661 59.9697 30.9948 74.9975 31.938C76.0999 32.0072 77.0002 31.0845 76.9997 29.98C76.9879 0.653585 76.451 0.0137214 52.0117 0.000281195C50.9071 -0.00032539 49.9957 0.897839 50.0375 2.00162Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair3);
export default __webpack_public_path__ + "static/media/Hair 3.830d4d59ce1a0e2f879541339c17a430.svg";
export { ForwardRef as ReactComponent };